import { DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT } from '../../gigs/DynamicGigCardCarouselWrapper/constants';
import { CARD_BORDER_EXTRA_SPACE, CARD_MARGIN_TOP } from './constants';

export const getCardHeight = () => {
    `${DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT - CARD_BORDER_EXTRA_SPACE - CARD_MARGIN_TOP * 4}px`;
};
